module.exports = __webpack_public_path__ + "static/img/bg-ar.c4ed4977.png";